module.exports = __webpack_public_path__ + "img/sketches.7fb537bf.webp";